import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

// eslint-disable-next-line
export const store = new Vuex.Store({
  state: {
    choixPerso: {
      etape: 1
    },
    reservation_client: {
      borne: {
      },
      client: {
        typeClient: "Particulier",
      },
      noEmojis: false,
      etape: 1,
      pre_reservation: null,
      evenement: {
      },
      livraison: {
      },
      optionSelected : [
      ]
    }
  },
  getters: {
    choixPerso: state => state.choixPerso,
    reservation_client: state => state.reservation_client,
    auth: state => state.auth,
  },
  mutations: {
    // Method for choix perso
    setEmail(state, email) {
      state.choixPerso.emailClient = email;
    },
    setTel(state, telClient) {
      state.choixPerso.telClient = telClient;
    },
    setNumeroDevis(state, numeroDevis) {
      state.choixPerso.numeroDevis = numeroDevis;
    },
    setTypeBorne(state, typeBorne) {
      state.choixPerso.typeBorne = typeBorne;
    },
    setIdPerso(state, idPerso) {
      state.choixPerso.idPerso = idPerso;
    },
    setPrenoms(state, prenoms) {
      state.choixPerso.prenoms = prenoms;
    },
    setDate(state, date) {
      state.choixPerso.date = date;
    },
    setCommentairePerso(state, commentairePerso) {
      state.choixPerso.commentairePerso = commentairePerso;
    },
    CPetapeNext(state) {
      state.choixPerso.etape++;
    },
    CPetapePrev(state) {
      state.choixPerso.etape--;
    },
    toggleDisplayDetail(state) {
      if (state.choixPerso.displayDetail) {
        state.choixPerso.displayDetail = false;
      } else {
        state.choixPerso.displayDetail = true;
      }
    },
    setTypePerso(state, typePerso) {
      state.choixPerso.typePerso = typePerso;
    },
    setNomDispo(state, nomDispo) {
      state.choixPerso.nomDispo = nomDispo;
    },
    setTitreDispo(state, titreDispo) {
      state.choixPerso.titreDispo = titreDispo;
    },
    addFilePerso(state, file) {
      state.choixPerso.fichiersPerso.push(file);
    },
    CPclear(state) {
      state.choixPerso.numeroDevis = "";
      state.choixPerso.emailClient = "";
      state.choixPerso.telClient = "";
      state.choixPerso.typeBorne = "";
      state.choixPerso.idPerso = "";
      state.choixPerso.typePerso = "";
      state.choixPerso.prenoms = "";
      state.choixPerso.date = "";
      state.choixPerso.commentairePerso = "";
      state.choixPerso.fichiersPerso = []
      state.choixPerso.fichiersPerso.nomDispo = "";
      state.choixPerso.titreDispo = "";
    },
    newCP(state) {
      state.choixPerso.etape = 1;
    },

    //Method for reservation client
    toggleNoEmojis(state) {
      state.reservation_client.noEmojis = !state.reservation_client.noEmojis;
    },
    RCetapeNext(state) {
      state.reservation_client.etape++;
    },
    RCetapePrev(state) {
      state.reservation_client.etape--;
    },
    RCsetTypeClient(state, typeClient) {
      state.reservation_client.client.typeClient = typeClient;
    },
    RCsetDateEvent(state, date) {
      state.reservation_client.evenement.date = date;
    },
    RCsetAddresseEvent(state, adresse) {
      state.reservation_client.evenement.adresse = adresse;
    },
    RCsetBorne(state, borne) {
      state.reservation_client.borne = borne;
    },
    RCsetMailTel(state, client) {
      state.reservation_client.client.telPortable = client.telClient;
      state.reservation_client.client.mail = client.mailClient;
    },
    RCsetPreReservation(state, id) {
      state.reservation_client.pre_reservation = id;
    },
    RCsetModeLiv(state, livraison) {
      state.reservation_client.livraison.mode = livraison.mode;
      state.reservation_client.livraison.price = livraison.price;
    },
    RCaddOption(state, option) {
      state.reservation_client.optionSelected.push(option);
    },
    RCrmOption(state, optionId) {
      for (var i = 0; i < state.reservation_client.optionSelected.length; i++) {
        if (state.reservation_client.optionSelected[i].id == optionId) {
          state.reservation_client.optionSelected.splice(i, 1);
        }
      }
    },
    RCclearOptionList(state) {
      state.reservation_client.optionSelected = [];
    },
    RCsetFinalEvent(state, evenement) {
      state.reservation_client.evenement.type = evenement.Type;
      state.reservation_client.evenement.heureDebut = evenement.HeureDebut;
      state.reservation_client.evenement.heureFin = evenement.HeureFin;
      state.reservation_client.evenement.nbInvites = evenement.NbInvites;
      state.reservation_client.evenement.commentaire = evenement.Commentaire;
    },
    RCsetFinalClient(state, client) {
      state.reservation_client.client.telPortable = client.telClient;
      state.reservation_client.client.mail = client.mailClient;
      state.reservation_client.client.nom = client.Nom;
      state.reservation_client.client.prenom = client.Prenom;
      state.reservation_client.client.societe = client.Societe;
      state.reservation_client.client.adresse = client.Adresse;
    },
    RCclear(state) {
      state.choixPerso.evenement = {};
      state.choixPerso.evenement.borne = {};
      state.choixPerso.evenement.client = {};
      state.choixPerso.evenement.livraison = {};
      state.choixPerso.evenement.optionSelected = [];
    }
  }
})


// WEBPACK FOOTER //
// ./src/store/store.js